import mediumSvg from "../src/assets/medium.svg";
import lowSvg from "../src/assets/low.svg";
import highSvg from "../src/assets/high.svg";

import lowPriority from "../src/assets/lowPriority.svg";
import mediumPriority from "../src/assets/mediumPriority.svg";
import highPriority from "../src/assets/highPriority.svg";
import type { Item } from "./components/Board";

export const STATUSES = ["To do", "In Progress", "Completed", "Dismissed"];
export type Status = (typeof STATUSES)[number];

export type EffortLevel = "low" | "medium" | "high"
export const effortMap: Record<EffortLevel, string> = {
  low: lowSvg,
  medium: mediumSvg,
  high: highSvg,
};

export const statusesColors: Record<Status, string> = {
  "To do": "#8B8D98",
  "In Progress": "#FFBA18",
  Completed: "#2B9A66",
  Dismissed: "#DC3E42",
};
export const priorities: {
  value: string;
  label: string;
  icon: React.ReactElement;
}[] = [
  {
    value: "low",
    label: "Low",
    icon: <img src={lowPriority}></img>,
  },
  {
    value: "medium",
    label: "Medium",
    icon: <img src={mediumPriority}></img>,
  },
  {
    value: "high",
    label: "High",
    icon: <img src={highPriority}></img>,
  },
];

export const efforts: {
  value: string;
  label: string;
  icon: React.ReactElement;
}[] = [
  {
    value: "low",
    label: "Low",
    icon: <img src={lowSvg}></img>,
  },
  {
    value: "medium",
    label: "Medium",
    icon: <img src={mediumSvg}></img>,
  },
  {
    value: "high",
    label: "High",
    icon: <img src={highSvg}></img>,
  },
];

export const types: {
  value: string;
  label: string;
  // icon: React.ReactNode;
}[] = [
  {
    value: "Guest Post",
    label: "Guest Post",
    // icon: <img src={lowSvg}></img>,
  },
  {
    value: "Outreach",
    label: "Outreach",
    // icon: <img src={mediumSvg}></img>,
  },
  {
    value: "Community",
    label: "Community",
    // icon: <img src={highSvg}></img>,
  },
  {
    value: "Owned Listicle",
    label: "Owned Listicle",
    // icon: <img src={highSvg}></img>,
  },
  {
    value: "Free Publish",
    label: "Free Publish",
    // icon: <img src={highSvg}></img>,
  },
  {
    value: "YouTube Video",
    label: "YouTube Video",
    // icon: <img src={highSvg}></img>,
  },
];


export const statuses: {
  value: string;
  label: string;
  icon: React.ReactNode;
}[] = [
  {
    value: "to-do",
    label: "To do",
    icon: <img src={lowPriority}></img>,
  },
  {
    value: "in-progress",
    label: "In Progress",
    icon: <img src={mediumPriority}></img>,
  },
  {
    value: "completed",
    label: "Completed",
    icon: <img src={highPriority}></img>,
  },
  {
    value: "dismissed",
    label: "Dismissed",
    icon: <img src={highPriority}></img>,
  },
];


export const INITIAL_ITEMS: Item[] = [
  {
    id: "1",
    status: "To do",
    clusterId: "",
    title: "Rebuild Figma’s Collaboration Tools Hub as an LLM‑Ready",
    description:
      "Guest posts on authoritative platforms increase external citations linked to your brand.",
    tag: "Outreach",
    completedITems: 2,
    allItems: 4,
    priority: "high",
    effort: "low",
    prompts: [
      { title: "Best website builder for designers" },
      { title: "How to create a website without coding knowledge?" },
      { title: "Which visual development platform is best for portfolios?" },
      { title: "Die besten No-Code-Website-Builder 2025" },
      { title: "Die besten No-Code-Website-Builder 2025" },
      { title: "Die besten No-Code-Website-Builder 2025" },
      { title: "Die besten No-Code-Website-Builder 2025" },
      { title: "Die besten No-Code-Website-Builder 2025" },

    ],
    tasks: [
      {
        title: "Enable notifications",
        description: "You can enable or disable notifications at any time.",
        done: true,
      },
      {
        title: "Enable notifications",
        description: "You can enable or disable notifications at any time.",
        done: false,
      },
    ],
  },
  {
    id: "2",
    status: "In Progress",
    clusterId: "",
    title: "Rebuild Figma’s Collaboration Tools Hub as an LLM‑Ready",
    description:
      "Guest posts on authoritative platforms increase external citations linked to your brand.",
    tag: "Guest Post",
    completedITems: 2,
    allItems: 4,
    priority: "medium",
    effort: "high",
    prompts: [
      { title: "Best website builder for designers" },
      { title: "How to create a website without coding knowledge?" },
      { title: "Which visual development platform is best for portfolios?" },
      { title: "Die besten No-Code-Website-Builder 2025" },
    ],
    tasks: [
      {
        title: "Enable notifications",
        description: "You can enable or disable notifications at any time.",
        done: true,
      },
      {
        title: "Enable notifications",
        description: "You can enable or disable notifications at any time.",
        done: false,
      },
    ],
  },
  {
    id: "3",
    status: "Completed",
    title: "Rebuild Figma’s Collaboration Tools Hub as an LLM‑Ready",
    description:
      "Guest posts on authoritative platforms increase external citations linked to your brand.",
    tag: "Guest Post",
     clusterId: "",
    completedITems: 2,
    allItems: 4,
    priority: "medium",
    effort: "medium",
    prompts: [
      { title: "Best website builder for designers" },
      { title: "How to create a website without coding knowledge?" },
      { title: "Which visual development platform is best for portfolios?" },
      { title: "Die besten No-Code-Website-Builder 2025" },
    ],
    tasks: [
      {
        title: "Enable notifications",
        description: "You can enable or disable notifications at any time.",
        done: false,
      },
      {
        title: "Enable notifications",
        description: "You can enable or disable notifications at any time.",
        done: true,
      },
    ],
  },
  {
    id: "4",
   clusterId: "",
    status: "Dismissed",
    title: "Rebuild Figma’s Collaboration Tools Hub as an LLM‑Ready",
    description:
      "Guest posts on authoritative platforms increase external citations linked to your brand.",
    tag: "Outreach",
    completedITems: 2,
    allItems: 4,
    priority: "low",
    effort: "low",
    prompts: [
      { title: "Best website builder for designers" },
      { title: "How to create a website without coding knowledge?" },
      { title: "Which visual development platform is best for portfolios?" },
      { title: "Die besten No-Code-Website-Builder 2025" },
    ],
    tasks: [
      {
        title: "Enable notifications",
        description: "You can enable or disable notifications at any time.",
        done: false,
      },
      {
        title: "Enable notifications",
        description: "You can enable or disable notifications at any time.",
        done: true,
      },
    ],
  },
];

export const getItemsWithIds = (id: string) => {
  return INITIAL_ITEMS.map((el, index) => {
    return {
      ...el,
      id: `${index}${id}`
    }
  })
}

export const clusters: {
  title: string;
  allItems: number;
  completed: number;
  underclusters: Item[];
}[] = [
  {
    title: "Best no-code website builder",
    allItems: 3,
    completed: 4,
    underclusters: getItemsWithIds("A"),
  },
  {
    title: "Platforms for creating landing pages",
    allItems: 3,
    completed: 4,
    underclusters: getItemsWithIds("B"),
  },
  {
    title: "Tools for building marketing websites",
    allItems: 3,
    completed: 4,
    underclusters: getItemsWithIds("C"),
  },
  {
    title: "Webflow vs Framer",
    allItems: 3,
    completed: 4,
    underclusters: getItemsWithIds("D"),
  },
];
